export default function ModuloBase({ onVolver, oscuro, titulo, icono, descripcion, proximamente = [] }) {
  const bg = oscuro ? "#09184D" : "#F0EEFF";
  const cardBg = oscuro ? "#0d2160" : "white";
  const texto = oscuro ? "#EDF2FA" : "#2F3E2E";
  const borde = oscuro ? "#1e3a8a" : "#eee";
  const navBg = oscuro ? "#060f30" : "#09184D";
  const subtexto = oscuro ? "#9aabd4" : "#808085";

  return (
    <div style={{ minHeight: "100vh", background: bg, fontFamily: "sans-serif" }}>
      <div style={{ background: navBg, padding: "1rem 1.5rem", display: "flex", alignItems: "center", justifyContent: "space-between", position: "sticky", top: 0, zIndex: 100 }}>
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <button onClick={onVolver} style={{ background: "rgba(255,255,255,0.1)", border: "none", color: "white", padding: "6px 14px", borderRadius: "10px", cursor: "pointer", fontSize: "13px" }}>← Menú</button>
          <span style={{ color: "white", fontWeight: "700", fontSize: "16px" }}>{titulo}</span>
        </div>
      </div>
      <div style={{ padding: "2rem", maxWidth: "700px", margin: "0 auto" }}>
        <div style={{ background: cardBg, borderRadius: "20px", padding: "3rem 2rem", border: `1px solid ${borde}`, textAlign: "center", marginBottom: "1.5rem" }}>
          <p style={{ fontSize: "56px", marginBottom: "1rem" }}>{icono}</p>
          <h2 style={{ fontSize: "20px", fontWeight: "700", color: texto, marginBottom: "12px" }}>{titulo}</h2>
          <p style={{ fontSize: "14px", color: subtexto, lineHeight: "1.7", maxWidth: "480px", margin: "0 auto 1.5rem" }}>{descripcion}</p>
          <div style={{ display: "inline-block", padding: "8px 20px", background: "rgba(123,91,242,.1)", border: "1px solid rgba(123,91,242,.3)", borderRadius: "20px", fontSize: "12px", fontWeight: "600", color: "#7B5BF2" }}>
            🚧 En desarrollo — Próximamente disponible
          </div>
        </div>
        {proximamente.length > 0 && (
          <div style={{ background: cardBg, borderRadius: "16px", padding: "1.5rem", border: `1px solid ${borde}` }}>
            <h3 style={{ fontSize: "14px", fontWeight: "600", color: texto, marginBottom: "12px" }}>Funcionalidades planificadas</h3>
            {proximamente.map((item, i) => (
              <div key={i} style={{ display: "flex", alignItems: "center", gap: "10px", padding: "8px 0", borderBottom: i < proximamente.length - 1 ? `0.5px solid ${borde}` : "none" }}>
                <span style={{ fontSize: "16px" }}>{item.icono}</span>
                <div>
                  <p style={{ fontSize: "13px", fontWeight: "600", color: texto, margin: 0 }}>{item.titulo}</p>
                  <p style={{ fontSize: "11px", color: subtexto, margin: 0 }}>{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}